const __getConfig = (e) => {
  // eslint-disable-next-line multiline-ternary
  const filterProfiles = e
    ? {
        login: [],
        serveronly: ["talkToServer"],
      }
    : {
        login: ["login", "auth", "talkToServer"],
        serveronly: ["talkToServer", "cache"],
        interval: ["interval", "talkToServer"],
      };

  const backendurl = e
    ? `https://${e}-v2.wellstat.io`
    : `http://${window.location.hostname}:8082`; // accounts for remote access and host.docker.intern for headless rendering in local development

  return {
    applicationName: "WellStat",
    errorTrackingToken:
      e === "prod"
        ? "https://429a72a0e51d407d9487a4e7a7a9709e@o30220.ingest.sentry.io/4503898728562688"
        : "",
    version: e || "development",
    filterProfiles,
    storageKeys: {
      AUTHTOKEN: "authToken",
    },
    httptimeout: 2000,
    servercommscount: 0,
    cachehitcount: 0,
    backendurl,
    salesurl: "https://www.wellstat.io/contact-us",
  };
};

export const appConfig = __getConfig(import.meta.env.VITE_REACT_APP_ENV);
